import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
//import aws4 from 'aws-v4-sign-small';

// Useful for testing.
// await new Promise((resolve, reject) => {setTimeout(resolve, 3000);});		
// return true;

export default class HttpService {

	constructor(app){
		this.app = app;
	}

	getAuthHeaders(){
		if(this.app.isTokenExpired){
			this.app.logout(false);
			console.log('Saw the token is expired. Logged out before trying request!');
			this.app.history.push('/');
			this.app.forceUpdate();
			throw new Error("Token is expired");
		}
		
		let authentication = this.app.localStorage('authentication');
		return { Accesstoken: authentication.AccessToken, Idtoken: authentication.IdToken };
	}

	async createUser({username, email, password, userType}){
		username = username.replace('@', '_'); // hack due to the error: Username cannot be of email format, since user pool is configured for email alias.
		return this.request({
			method: 'post',
			url: this.baseURL + '/users',
			data: { username, email, password, userType }
		});
	}

	async updateProfile(profileBody){
		let authentication = this.app.localStorage('authentication');
		//username = username.replace('@', '_'); // hack due to the error: Username cannot be of email format, since user pool is configured for email alias.
		
		profileBody = {...profileBody, id:authentication.IdentityId}
		
		return this.request({
			method: 'put',
			url: this.baseURL + `/users/${authentication.IdentityId}`,
			data: profileBody,
			headers: this.getAuthHeaders()
		});
	}

	async deleteUser(){
		let authentication = this.app.localStorage('authentication');
		return this.request({
			method: 'delete',
			url: this.baseURL + `/users/${authentication.IdentityId}`,
			headers: this.getAuthHeaders()
		}, true);
	}

	async loginUser({username, password}){
		username = username.replace('@', '_');
		return this.request({
			method: 'post',
			url: this.baseURL + '/session',
			data: { username, password }
		});
	}

	async getUser(){
		let authentication = this.app.localStorage('authentication');

		return this.request({
			method: 'get',
			url: this.baseURL + `/users/${authentication.IdentityId}`,
			headers: this.getAuthHeaders()
		}, true);
	}

	async logoutUser({AccessToken}){
		return this.request({
			method: 'delete',
			url: this.baseURL + '/session',
			headers: this.getAuthHeaders(),
			data: {AccessToken}
		}, true);
	}

	async requestPasswordReset({username}){
		username = username.replace('@', '_');
		return this.request({
			method: 'post',
			url: this.baseURL + '/password_reset',
			data: { username }
		});
	}

	async confirmPasswordReset({username, password, confirmationCode}){
		username = username.replace('@', '_');
		return this.request({
			method: 'put',
			url: this.baseURL + '/password_reset',
			data: { username, password, confirmationCode }
		});
	}

	async createExperiment({experiment}){
		return this.request({
			method: 'post',
			url: this.baseURL + '/experiment',
			data: experiment,
			headers: this.getAuthHeaders()
		}, true);
	} // RESPONSE: {"name":"Experiment #1 3/22 10:54","experimentId":"bc6c70ad-3234-4692-a6f3-fc8eb5adc30b","researcherId":"us-east-1:34f7c4b4-f02e-4458-bea6-66a2467139b1"}

	async duplicateExperiment({experimentId}){
		return this.request({
			method: 'post',
			url: this.baseURL + `/experiment/${experimentId}`,
			headers: this.getAuthHeaders()
		}, true);
	}

	// TODO: This only returns the name. We need all the fields, like we get returned in getExperiments
	async getExperiment({experimentId}){
		return this.request({
			method: 'get',
			url: this.baseURL + `/experiment/${experimentId}`,
			headers: this.getAuthHeaders()
		}, true);
	} // RESPONSE: {"name":"Experiment #1 3/22 10:54","experimentId":"bc6c70ad-3234-4692-a6f3-fc8eb5adc30b","researcherId":"us-east-1:34f7c4b4-f02e-4458-bea6-66a2467139b1"}

	async getExperimentResponses({experimentId, format = 'json', pruned = true, downloadFile=false}){
		let responsesType = (format === 'csv' && pruned) ? "pruned_responses" : "responses";
		let response = await this.request({
			method: 'get',
			url: this.baseURL + `/experiment/${experimentId}/` + responsesType,
			headers: {...this.getAuthHeaders(), Accept: {json:'application/json', csv:'text/csv'}[format] }
		}, true);

		if(downloadFile){
			this.downloadFile(`ExperimentResponses.${format}`, format === 'json' ? JSON.stringify(response, null, '\t') : response);
		}

		return response;

	} // RESPONSE: {"name":"Experiment #1 3/22 10:54","experimentId":"bc6c70ad-3234-4692-a6f3-fc8eb5adc30b","researcherId":"us-east-1:34f7c4b4-f02e-4458-bea6-66a2467139b1"}


	async getParticipantExperimentHistory(){
		let responses = await this.request({
			method: 'get',
			url: this.baseURL + `/participant/response`,
			headers: this.getAuthHeaders(),
		}, true);

		responses = responses || [];
		responses = _.sortBy(responses, 'completionDate');

		let balance = 0;
		responses.forEach( response => {
			balance += (+response.incentive || 0);
			response.completionDateFormatted = moment(response.completionDate).format('ll');
		});
		return {earnings:balance, experiments:responses};
	}
	/*
	[
		{"experimentName":"Super Simple Its So Easy!","incentive":"1","participantId":"us-east-1:34f7c4b4-f02e-4458-bea6-66a2467139b1","experimentId":"53dd3ed7-a053-44c8-813e-5d5b0616de49","completionDate":1524968266087},
		{"experimentName":"Re-take test","incentive":"1","participantId":"us-east-1:34f7c4b4-f02e-4458-bea6-66a2467139b1","experimentId":"6c8972dd-27e1-4095-9f2a-e2dda9cf037b","completionDate":1524628589779}
	]
	*/



	// async getExperiment({experimentId}){
	// 	const experiments = await this.getResearcherExperiments();
	// 	return experiments.find( experiment => experiment.experimentId === experimentId);
	// }

	async getResearcherExperiments(){
		return this.request({
			method: 'get',
			url: this.baseURL + `/researcher/experiment`,
			headers: this.getAuthHeaders()
		}, true);
	} 

	async getParticipantExperiments(){
		return this.request({
			method: 'get',
			url: this.baseURL + `/participant/experiment`,
			headers: this.getAuthHeaders()
		}, true);
	} 
	/* RESPONSE: 
	[
		{"experimentId":"175d948c-b04a-4469-9afd-edc1cead108c","researcherId":"us-east-1:01fa5c16-ec5a-4efe-8db1-485792993dee","name":"My Experiment 2"},
		{"amount":10,"experimentId":"Xbc6c70ad-3234-4692-a6f3-fc8eb5adc30b","researcherId":"us-east-1:34f7c4b4-f02e-4458-bea6-66a2467139b1","name":"Experiment #1 3/22 10:54 2"},
		{"experimentId":"6bfb4b9d-eb59-4379-8fc2-995fa98adaad","researcherId":"us-east-1:01fa5c16-ec5a-4efe-8db1-485792993dee","name":"My Experiment 3"},
	]
	*/

	async updateExperiment({experiment}){
		return this.request({
			method: 'put',
			url: this.baseURL + `/experiment/${experiment.experimentId}`,
			data: experiment,
			headers: this.getAuthHeaders()
		}, true);
	} // RESPONSE: {"name":"Experiment #1 3/22 10:54","experimentId":"bc6c70ad-3234-4692-a6f3-fc8eb5adc30b","researcherId":"us-east-1:34f7c4b4-f02e-4458-bea6-66a2467139b1"}

	async startExperiment({experimentId}){
		return this.request({
			method: 'post',
			url: this.baseURL + `/response/${experimentId}`,
			headers: this.getAuthHeaders()
		}, true);
	}

	async sendExperimentResponse({response, environment, experiment}){
		return this.request({
			method: 'put',
			url: this.baseURL + `/response/${experiment.experimentId}`,
			data: {events:response, environment},
			headers: this.getAuthHeaders()
		}, true);
	}

	async uploadAsset({experiment, file}){
		let authentication = this.app.localStorage('authentication');
		return this.request({
			method: 'put',
			url: this.baseURL + `/users/${authentication.IdentityId}/experiments/${experiment.experimentId}/assets/${encodeURIComponent(file.name)}`,
			data: file.base64,
			headers: {...this.getAuthHeaders(), 'Content-Type':'text/plain'}
		}, true);
	}
	//RESPONSE: {"ETag":"\"dbe16c95526ab103c19861b301df885a\""}

	async getAsset({experiment, file}){
		let authentication = this.app.localStorage('authentication');
		return this.request({
			method: 'get',
			url: this.baseURL + `/users/${authentication.IdentityId}/experiments/${experiment.experimentId}/assets/${file.name}`,
			headers: {...this.getAuthHeaders()}
		}, true);
	}

	async getAssetList({experiment, file}){
		let authentication = this.app.localStorage('authentication');
		const response = await this.request({
			method: 'get',
			url: this.baseURL + `/users/${authentication.IdentityId}/experiments/${experiment.experimentId}/assets`,
			headers: {...this.getAuthHeaders()}
		}, true);

		return response.Contents.map(item => { 
			return {
				name: _.last(item.Key.split('/')),
				size: this.formatBytes(item.Size),
			}; 
		});

	}
	/*
	RESPONSE: 
	{
		"IsTruncated": false,
		"Marker": "",
		"Contents": [
			{
				"Key": "users/us-east-1:34f7c4b4-f02e-4458-bea6-66a2467139b1/experiments/1e2692c2-b524-49d2-aa72-52c6845523e5/assets/t1.png",
				"LastModified": "2018-04-06T05:10:21.000Z",
				"ETag": "\"dbe16c95526ab103c19861b301df885a\"",
				"Size": 643,
				"StorageClass": "STANDARD",
				"Owner": {
					"DisplayName": "jeremy_clark1",
					"ID": "cb43bee31ecbe80f1f937d2310de583c1f764e7b9c86a435e941d9509c33dcd7"
				}
			}
		],
		"Name": "venkman-assets",
		"Prefix": "users/us-east-1:34f7c4b4-f02e-4458-bea6-66a2467139b1/experiments/1e2692c2-b524-49d2-aa72-52c6845523e5/assets/",
		"Delimiter": "/",
		"MaxKeys": 1000,
		"CommonPrefixes": []
	}
	*/

	async optInToEmails(){
		return this.request({
			method: 'post',
			url: this.baseURL + `/messageconsent`,
			//data:this.getAuthHeaders(),
			headers: this.getAuthHeaders()
		}, true);
	}

	async getOptInToEmailsStatus(){
		let result = await this.request({
			method: 'get',
			url: this.baseURL + `/messageconsent`,
			headers: this.getAuthHeaders()
		}, true);

		let status = 'Not yet requested';

		if(result && result.VerificationAttributes){
			status = _.get(Object.values(result.VerificationAttributes), '[0].VerificationStatus', 'Not yet requested'); 
		}
		return status;
	}
	/*
	{
		"ResponseMetadata": {
			"RequestId": "6bd8835b-468b-11e8-9d76-cd1b32d39478"
		},
		"VerificationAttributes": {
			"jerclark+1524435849391@gmail.com": {
				"VerificationStatus": "Pending"
			}
		}
	}
	*/

	async sendEmail({messageToken, messageBody, messageSubject, messageReplyTo = "auto-send@venkmanscience.com"}){
		return this.request({
			method: 'post',
			url: this.baseURL + `/message`,
			data: {messageToken, messageBody, messageSubject, messageReplyTo},
			headers: this.getAuthHeaders()
		}, true);
	}







	get baseURL(){
		return this.app.baseURL;
	}

	async request(config, signRequest = false){

		try{

			// if(signRequest){
			// 	this.signRequest(config);
			// }

			const response = await axios(config);
			return response.data || {};
		} catch (e){
			throw new Error(_.get(e, 'response.data.message', e));
		}
	}

	getLocation(url){
		let tempLink = document.createElement("a");
		tempLink.href = url;
		return tempLink;
	}

	//https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
	formatBytes(a,b){
		a = +a; if(0===a)return"0 Bytes";var c=1024,d=b||2,e=["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"],f=Math.floor(Math.log(a)/Math.log(c));return parseFloat((a/Math.pow(c,f)).toFixed(d))+" "+e[f];
	}

	downloadFile(filename, text) {
		this.downloadFile2({data:text, filename, mime: filename.includes('.csv') ? 'text/csv' : 'application/json' });
	  }

	downloadFile2({data, filename, mime}) {
		var blob = new Blob([data], {type: mime || 'application/octet-stream'});
		if (typeof window.navigator.msSaveBlob !== 'undefined') {
			// IE workaround for "HTML7007: One or more blob URLs were 
			// revoked by closing the blob for which they were created. 
			// These URLs will no longer resolve as the data backing 
			// the URL has been freed."
			window.navigator.msSaveBlob(blob, filename);
		}
		else {
			var blobURL = window.URL.createObjectURL(blob);
			var tempLink = document.createElement('a');
			tempLink.style.display = 'none';
			tempLink.href = blobURL;
			tempLink.setAttribute('download', filename); 
			
			// Safari thinks _blank anchor are pop ups. We only want to set _blank
			// target if the browser does not support the HTML5 download attribute.
			// This allows you to download files in desktop safari if pop up blocking 
			// is enabled.
			if (typeof tempLink.download === 'undefined') {
				tempLink.setAttribute('target', '_blank');
			}
			
			document.body.appendChild(tempLink);
			tempLink.click();
			document.body.removeChild(tempLink);
			window.URL.revokeObjectURL(blobURL);
		}
	}

	// signRequest(config){

	// 	//config.url = 'https://220mtkd7ng.execute-api.us-east-1.amazonaws.com/Stage/experiment';

	// 	let tempLink = this.getLocation(config.url);
	// 	config.host = tempLink.hostname;
	// 	config.path = tempLink.pathname;

	// 	// will these automatically work from the url? What about in local dev.
	// 	config.service = 'execute-api';
	// 	config.region = 'us-east-1';

	// 	config.headers = config.headers || {};
	// 	config.headers ={
	// 		'Content-Type': 'application/json',
	// 		Accept: 'application/json',
	// 		...config.headers,
	// 	};

	// 	config.method = config.method.toUpperCase();

	// 	/*
	// 	const options = {
	// 		service: 'execute-api',
	// 		region: 'us-east-1',
	// 		url: "https://220mtkd7ng.execute-api.us-east-1.amazonaws.com/Stage/experiment",
	// 		hostname: "220mtkd7ng.execute-api.us-east-1.amazonaws.com",
	// 		path: '/Stage/experiment',
	// 		method: 'POST',
	// 		headers:  {
	// 		  'Content-Type': 'application/json',
	// 		  'Accept': 'application/json',
	// 		  'authToken': idToken
	// 		}
	// 	};
	// 	*/

	// 	const authentication = this.app.localStorage('authentication');
	// 	if(!authentication || !authentication.Credentials){
	// 		throw new Error("No authentication can be found in local storage.");
	// 	}

	// 	const sigCredentials = {
	// 		accessKeyId:     authentication.Credentials.AccessKeyId,
	// 		secretAccessKey: authentication.Credentials.SecretKey,
	// 		sessionToken:    authentication.Credentials.SessionToken
	// 	}

	// 	//console.log('unsigned', config);
	// 	const signedConfig = aws4.sign(config, sigCredentials);
	// 	//console.log('signed', signedConfig);
	// 	delete signedConfig.headers.host; // Browser complains about this.
	// 	return signedConfig;
	// }


}




// WEBPACK FOOTER //
// ./src/models/HttpService.js